import React from "react";

// Aère les longs textes : respecte les sauts de ligne existants et, à défaut,
// regroupe les phrases par 2 pour créer des paragraphes lisibles.
function toParagraphs(text) {
  const raw = (text || "").trim();
  if (!raw) return [];
  let parts = raw.split(/\n{2,}/).map((p) => p.trim()).filter(Boolean);
  if (parts.length <= 1) parts = raw.split(/\n+/).map((p) => p.trim()).filter(Boolean);
  const out = [];
  for (const part of parts) {
    if (part.length > 220 && !/\n/.test(part)) {
      const sentences = part.match(/[^.!?]+[.!?]+(\s|$)/g) || [part];
      for (let i = 0; i < sentences.length; i += 2) {
        out.push(sentences.slice(i, i + 2).join(" ").trim());
      }
    } else {
      out.push(part);
    }
  }
  return out;
}

export function Prose({ text, className = "", pClassName = "" }) {
  const paras = toParagraphs(text);
  if (!paras.length) return null;
  return (
    <div className={className} data-testid="prose">
      {paras.map((p, i) => (
        <p key={i} className={pClassName} style={{ marginBottom: i < paras.length - 1 ? "0.9em" : 0 }}>{p}</p>
      ))}
    </div>
  );
}
